import { useUserStore } from '@/store'

// 权限指令 - 检查用户是否拥有指定权限
const permissionDirective = {
  mounted(el, binding) {
    const userStore = useUserStore()
    const { value } = binding
    
    // 确保权限值正确
    if (!value || (typeof value !== 'string' && !Array.isArray(value))) {
      console.error('权限指令需要有效的权限值')
      return
    }
    
    // 检查权限
    let hasAccess = false
    if (typeof value === 'string') {
      hasAccess = userStore.hasPermission(value)
    } else if (Array.isArray(value)) {
      hasAccess = userStore.hasAnyPermission(value)
    }
    
    // 没有权限则隐藏元素
    if (!hasAccess) {
      el.style.display = 'none'
    }
  },
  
  // 当权限变化时更新
  updated(el, binding) {
    const userStore = useUserStore()
    const { value } = binding
    
    if (!value || (typeof value !== 'string' && !Array.isArray(value))) {
      return
    }
    
    let hasAccess = false
    if (typeof value === 'string') {
      hasAccess = userStore.hasPermission(value)
    } else if (Array.isArray(value)) {
      hasAccess = userStore.hasAnyPermission(value)
    }
    
    el.style.display = hasAccess ? '' : 'none'
  }
}

// 角色指令 - 检查用户是否拥有指定角色
const roleDirective = {
  mounted(el, binding) {
    const userStore = useUserStore()
    const { value } = binding
    
    if (!value || (typeof value !== 'string' && !Array.isArray(value))) {
      console.error('角色指令需要有效的角色值')
      return
    }
    
    let hasAccess = false
    if (typeof value === 'string') {
      hasAccess = userStore.hasRole(value)
    } else if (Array.isArray(value)) {
      hasAccess = userStore.hasAnyRole(value)
    }
    
    if (!hasAccess) {
      el.style.display = 'none'
    }
  },
  
  updated(el, binding) {
    const userStore = useUserStore()
    const { value } = binding
    
    if (!value || (typeof value !== 'string' && !Array.isArray(value))) {
      return
    }
    
    let hasAccess = false
    if (typeof value === 'string') {
      hasAccess = userStore.hasRole(value)
    } else if (Array.isArray(value)) {
      hasAccess = userStore.hasAnyRole(value)
    }
    
    el.style.display = hasAccess ? '' : 'none'
  }
}

// 权限过滤器 - 用于模板中的条件渲染
export const permissionFilters = {
  // 检查是否有权限
  hasPermission: (permission) => {
    const userStore = useUserStore()
    return userStore.hasPermission(permission)
  },
  
  // 检查是否有任意一个权限
  hasAnyPermission: (permissions) => {
    const userStore = useUserStore()
    return userStore.hasAnyPermission(permissions)
  },
  
  // 检查是否是指定角色
  hasRole: (role) => {
    const userStore = useUserStore()
    return userStore.hasRole(role)
  },
  
  // 检查是否是任意一个指定角色
  hasAnyRole: (roles) => {
    const userStore = useUserStore()
    return userStore.hasAnyRole(roles)
  }
}

// 注册权限指令
export const registerPermissionDirectives = (app) => {
  // 单个权限检查
  app.directive('permission', permissionDirective)
  
  // 角色检查
  app.directive('role', roleDirective)
  
  // 任意权限检查（逻辑或）
  app.directive('any-permission', permissionDirective)
  
  // 任意角色检查（逻辑或）
  app.directive('any-role', roleDirective)
  
  // 注册过滤器到全局属性
  Object.keys(permissionFilters).forEach(key => {
    app.config.globalProperties[`$${key}`] = permissionFilters[key]
  })
}

export default {
  registerPermissionDirectives,
  permissionFilters
}